<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { authComputed } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
import store from "@/state/store";
import VueHtml2pdf from "vue-html2pdf";
import Multiselect from "vue-multiselect";
export default {
  beforeRouteEnter(to, from, next) {
    const userType = store.getters["auth/getUser"].user_type;
    const permissions = store.getters["auth/permissions"];
    if (
      (userType === 1 || userType === 3) &&
      permissions.includes("SELF_ASSESSMENT")
    ) {
      next();
    } else {
      alert("You are not allowed to access this page. You will be redirected.");
      next("/");
    }
  },
  page: {
    title: "Self Assessment Details",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    VueHtml2pdf,
  },
  computed: {
    ...authComputed,
  },
  async mounted() {
    this.fetchAuthorizingOfficers();
    this.fetchEmployees();

    this.activity = this.$route.params.activity;
    if (parseInt(this.activity) === 1) {
      await this.getSelfAssessment();
    } else if (parseInt(this.activity) === 2) {
      await this.midYearAssessments();
    } else {
      await this.prefillAssessment();
    }
    await this.fetchEmployee();
  },
  validations: {
    start: { required },
    end: { required },
    duration: { required },
    assignedTo: { required },
    reAssignedTo: { required },
  },

  data() {
    return {
      title: "Self Assessment Details",
      items: [
        {
          text: "IHUMANE",
        },
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Self Assessment Details",
          href: "#",
          active: true,
        },
      ],
      //mid year

      //beginning of year
      authuser: null,
      goalSettingId: null,
      updating: false,
      texts: [{ id: 0, goal: null }],
      assessStatus: 0,
      samStatus: 0,
      year: null,
      rating: null,
      ratingStatus: null,
      ratings: [],
      ratingsArray: [],
      ratingsStatuses: [],
      employeeRating: null,
      goals: [],
      start: "",
      end: "",
      duration: 0,
      submitted: false,
      count: 0,
      selfAssessmentStatus: false,
      prefillStatus: false,
      selfAssessmentGoals: [],
      endYearAssessments: [],
      assessments: [],
      employee: [],
      prefillAssessments: [],
      currentEmployee: null,
      gsID: null,
      //end of year
      openGoalActivity: null,
      openGoalActivityYear: null,
      openGoalActivityFrom: null,
      openGoalActivityTo: null,
      openGoalActivityId: null,
      checkOpenGoal: 0,
      empId: null,
      endOfYearQuestions: null,
      midYearCheckingQuestions: null,
      endOfYearQuestionOptions: [
        { text: "Yes", value: "yes" },
        { text: "No", value: "no" },
      ],
      eyr_strength: null,
      eyr_growth_area: null,
      supervisorResponse: null,
      selectedYear: null,
      selectedStart: null,
      selectedEnd: null,
      employeeId: null,
      selectedEmp: [],
      eId: null,
      activity: null,
      activityId: null,
      sam_discussion_held_on: null,
      officials: [
        {
          value: null,
          text: "Please choose the next reviewer",
          disabled: true,
        },
      ],
      assignedOfficials: [
        {
          value: null,
          text: "Please choose the next reviewer",
          disabled: true,
        },
      ],
      reAssignedTo: null,
      assignedTo: null,
    };
  },
  methods: {
    async fetchEmployee() {
      this.employeeId = this.$route.params.employee;
      const url = `${this.ROUTES.employee}/get-employee/${this.employeeId}`;
      this.apiGet(url, "Get Employee Error").then((res) => {
        const { data } = res;
        if (data) {
          this.employee.push(data);
        }
      });
    },
    fetchEmployees() {
      this.apiGet(this.ROUTES.employee, "Get Employees Error").then((res) => {
        this.officials = [
          {
            value: null,
            text: "Please choose an officer",
            disabled: true,
          },
        ];
        const { data } = res;
        data.forEach((employee) => {
          this.officials.push({
            value: employee.emp_id,
            text: `${employee.emp_first_name} ${employee.emp_last_name} (${employee.emp_unique_id})`,
          });
        });
      });
    },
    fetchAuthorizingOfficers() {
      let leaveId = this.$route.params.leaveAppID;
      const url = `${this.ROUTES.authorization}/4/${leaveId}`; //4 = for self-assessment
      this.apiGet(url, "Get Employees Error").then((res) => {
        this.assignedOfficials = [
          {
            value: null,
            text: "Please choose an officer",
            disabled: true,
          },
        ];
        const { data } = res;
        data.forEach((officer) => {
          this.assignedOfficials.push({
            value: officer.officers.emp_id,
            text: `${officer.officers.emp_first_name} ${officer.officers.emp_last_name} (${officer.officers.emp_unique_id})`,
          });
        });
      });
    },
    employeeLabel({ text }) {
      return `${text}`;
    },
    reAssignLabel({ text }) {
      return `${text}`;
    },

    async prefillAssessment() {
      this.selectedYear = this.$route.params.year;
      this.employeeId = this.$route.params.employee;
      this.activity = this.$route.params.activity;
      this.activityId = this.$route.params.activityId;
      let url = `${this.ROUTES.endYearResponse}/get-end-year/${this.employeeId}/${this.activityId}`;
      this.apiGet(url).then(async (res) => {
        const { data } = res;
        if (data.length) {
          //console.log(data)
          this.selectedStart = localStorage.getItem("startDate");
          this.selectedEnd = localStorage.getItem("endDate");
          this.gsId = data[0].eyr_gs_id;
          this.goalMasterId = data[0].eyr_master_id;
          await this.getSupervisorEndYearResponse();
          this.midYearCheckingQuestions = data.filter((entry) => {
            return entry.eyr_type === 1;
          });
          this.midYearCheckingQuestions.forEach((question, index) => {
            this.midYearCheckingQuestions[index] = {
              ...question,
              sa_comment: question.eyr_goal,
            };
          });
          this.eyr_strength = data[0].eyr_strength;
          this.eyr_growth_area = data[0].eyr_growth_area;
          this.endOfYearQuestions = data.filter((entry) => {
            return entry.eyr_type === 2;
          });
          this.endOfYearQuestions.forEach((question, index) => {
            this.endOfYearQuestions[index] = {
              ...question,
              eya_question: question.eyr_goal,
            };
          });
        }
      });
    },
    async getSupervisorEndYearResponse() {
      const url = `${this.ROUTES.endYearResponse}/supervisor-end-year-response/${this.goalMasterId}`;
      this.apiGet(url, "Get Supervisor End Year Response Error").then((res) => {
        const { data } = res;
        this.supervisorResponse = data[0];
        //console.log(this.supervisorResponse);
        this.sam_discussion_held_on = new Date(
          this.supervisorResponse.selfAssessment.sam_discussion_held_on
        )
          .toISOString()
          .substr(0, 10);
      });
    },
    async midYearAssessments() {
      this.masterId = this.$route.params.masterId;
      this.selectedYear = this.$route.params.year;
      this.employeeId = this.$route.params.employee;
      this.activity = this.$route.params.activity;
      this.activityId = this.$route.params.activityId;
      const url = `${this.ROUTES.selfAssessment}/get-self-assessment-by-master/${this.masterId}`;
      await this.apiGet(url).then((res) => {
        const { data } = res;
        this.samStatus = data.master.sam_status;
        this.selectedStart = data.openGoal[0].gs_from;
        this.selectedEnd = data.openGoal[0].gs_to;
        localStorage.setItem("startDate", this.selectedStart);
        localStorage.setItem("endDate", this.selectedEnd);
        if (data.question.length > 0) {
          this.texts = [];
          this.optional = data.master?.sam_optional;
          this.sam_discussion_held_on = new Date(
            data.master?.sam_discussion_held_on
          )
            .toISOString()
            .substr(0, 10);
          this.assessStatus = data.question[0].sa_status;
          data.question.forEach(async (datum) => {
            this.selfAssessmentStatus = true;
            this.prefillStatus = true;
            const dat = {
              id: datum.sa_id,
              goal: datum.sa_comment,
              update: datum.sa_update,
              accomplishment: datum.sa_accomplishment,
              next_step: datum.sa_next_steps,
              challenge: datum.sa_challenges,
              support: datum.sa_support_needed,
            };
            this.texts.push(dat);
          });
        }
      });
    },
    async getSelfAssessment() {
      this.selectedYear = this.$route.params.year;
      this.employeeId = this.$route.params.employee;
      this.activity = this.$route.params.activity;
      this.activityId = this.$route.params.activityId;
      const url = `${this.ROUTES.selfAssessment}/get-self-assessment/${this.employeeId}/${this.activityId}`;
      await this.apiGet(url).then((res) => {
        const { data } = res;
        //console.log(data);
        this.assessments = [];
        this.samStatus = data.master.sam_status;
        this.assessStatus = data.questions[0].sa_status;
        this.gsID = data.openGoal[0].gs_id;
        this.selectedYear = data.openGoal[0].gs_year;
        this.selectedStart = data.openGoal[0].gs_from;
        this.selectedEnd = data.openGoal[0].gs_to;
        localStorage.setItem("startDate", this.selectedStart);
        localStorage.setItem("endDate", this.selectedEnd);
        data.questions.forEach(async (datum) => {
          const dat = {
            id: datum.sa_id,
            goal: datum.sa_comment,
            response: datum.sa_response,
            update: datum.sa_update,
            challenge: datum.sa_challenges,
            next_step: datum.sa_next_steps,
            support: datum.sa_support_needed,
            accomplishment: datum.sa_accomplishment,
            status: parseInt(datum.sa_status),
          };
          this.assessments.push(dat);
        });
      });
    },
    restateSelfAssessment() {
      this.submitted = true;
      this.updating = true;
      let eId = this.empId;
      if(eId === null ||  eId === ''){
        alert("Select who you'll like to re-assign this to.");
        return false;
      }

      this.selectedYear = this.$route.params.year;
      this.employeeId = parseInt(this.$route.params.employee);
      const reAssignTo = this.empId.value;
      this.activity = parseInt(this.$route.params.activity);
      this.activityId = parseInt(this.$route.params.activityId);

      let url = `${this.ROUTES.selfAssessment}/restate-self-assessment/${this.activityId}/0/${this.employeeId}/${this.selectedYear}/${reAssignTo}`;
      this.apiGet(url, "Re-state Self-assessment Error")
        .then(() => {
          this.apiResponseHandler("Process Complete", "Self-assessment re-stated!");
          this.submitted = false;
          this.updating = false;
        })
        .finally(() => {
          this.updating = false;
        });
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    restateMidYearSelfAssessment() {
      this.submitted = true;
      this.updating = true;
      let eId = this.empId;
      if(eId === null ||  eId === ''){
        alert("Select who you'll like to re-assign this to.");
        return false;
      }

      this.selectedYear = this.$route.params.year;
      this.employeeId = parseInt(this.$route.params.employee);
      const reAssignTo = this.empId;
      this.activity = parseInt(this.$route.params.activity);
      this.activityId = parseInt(this.$route.params.activityId);

      let url = `${this.ROUTES.selfAssessment}/restate-self-assessment/${this.activityId}/0/${this.employeeId}/${this.selectedYear}/${reAssignTo}`;
      this.apiGet(url, "Re-state Self-assessment Error")
        .then(() => {
          this.apiResponseHandler("Process Complete", "Self-assessment re-stated!");
          this.submitted = false;
          this.updating = false;
        })
        .finally(() => {
          this.updating = false;
        });
    },
    authorizingAsLabel({ text }) {
      return `${text}`;
    },
  },
};
</script>
<style>
.back {
  cursor: pointer;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <scale-loader v-if="apiBusy" />
    <div class="row" v-else>
      <div class="col-md-12 d-flex justify-content-end">
        <div class="mb-3">
          <b-button class="btn btn-secondary" @click="$router.go(-1)">
            <i class="mdi mdi-step-backward mr-2"></i>
            Go Back
          </b-button>
          <b-button class="btn btn-success" @click="generateReport">
            <i class="mdi mdi-printer mr-2"></i>
            Print
          </b-button>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="media mb-3">
              <div>
                <span
                  class="badge badge-primary badge-pill"
                  v-if="parseInt(activity) === 1"
                >
                  Beginning of Year
                </span>
                <span
                  class="badge badge-primary badge-pill"
                  v-else-if="parseInt(activity) === 2"
                >
                  Mid-Year
                </span>
                <span class="badge badge-primary badge-pill" v-else>
                  End of Year
                </span>
                <span class="badge badge-primary badge-pill ml-3">
                  {{ selectedYear }}
                </span>
              </div>
            </div>
            <div class="row" v-if="parseInt(activity) === 1">
              <div class="col-lg-12">
                <h5 class="mb-2">Beginning of Year: {{ selectedYear }}</h5>
                <h5 class="mb-1">
                  Review Period
                  {{ new Date(selectedStart).toDateString() }} -
                  {{ new Date(selectedEnd).toDateString() }}
                </h5>
                <div class="row">
                  <div class="col-md-8">
                    <div class="row">
                      <div class="col-6">
                        <div class="card mb-4">
                          <div class="card-body">
                            <div class="p-3 bg-light mb-4">
                              <h5 class="font-size-14 mb-0">Supervisor Details</h5>
                            </div>
                            <div
                              class="d-flex justify-content-between text-capitalize"
                            >
                              <p>Supervisor Name</p>
                              <p>
                                {{ employee[0].supervisor.emp_first_name }}
                                {{ employee[0].supervisor.emp_last_name }}
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p>T7 Number</p>
                              <p>
                                {{ employee[0].supervisor.emp_unique_id }}
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p>Phone Number</p>
                              <p>
                                {{ employee[0].supervisor.emp_phone_no }}
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p>Office Email</p>
                              <p>
                                {{ employee[0].supervisor.emp_office_email }}
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p>Sector Code</p>
                              <p>
                                {{ employee[0].supervisor.sector.d_t3_code }}
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p>Location Code</p>
                              <p>
                                {{ employee[0].supervisor.location.l_t6_code }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="card mb-4">
                          <div class="card-body">
                            <div class="p-3 bg-light mb-4">
                              <h5 class="font-size-14 mb-0">Employee Details</h5>
                            </div>
                            <div
                              class="d-flex justify-content-between text-capitalize"
                            >
                              <p>Employee Name</p>
                              <p>
                                {{ employee[0].emp_first_name }}
                                {{ employee[0].emp_last_name }}
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p>T7 Number</p>
                              <p>
                                {{ employee[0].emp_unique_id }}
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p>Phone Number</p>
                              <p>
                                {{ employee[0].emp_phone_no }}
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p>Office Email</p>
                              <p>
                                {{ employee[0].emp_office_email }}
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p>Sector Code</p>
                              <p>
                                {{ employee[0].sector.d_t3_code }}
                              </p>
                            </div>
                            <div class="d-flex justify-content-between">
                              <p>Location Code</p>
                              <p>
                                {{ employee[0].location.l_t6_code }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-12"
                        v-for="(field, index) in assessments"
                        :key="index"
                      >
                        <div class="form-group">
                          <label for="goal" class="bg-light p-1">
                            Goal
                            <span class="badge-danger badge">{{ index + 1 }}</span>
                          </label>
                          <p
                            style="margin-left: 30px !important"
                            v-html="field.goal"
                          ></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="card">
                      <div class="card-body">
                        <div class="p-3 bg-light mb-4 d-flex justify-content-between" style="background: #58181F !important; color:#fff !important;">
                          <div class="d-inline mb-0">
                            <h5 class="font-size-14 mb-0 text-white">Application Re-assignment</h5>
                          </div>
                        </div>
                        <div class="mb-3">
                          <form >
                            <div class="form-group">
                              <label for="">From:</label>
                              <multiselect
                                id="assignedTo"
                                v-model="assignedTo"
                                :options="assignedOfficials"
                                :custom-label="employeeLabel"
                                :class="{
                                  'is-invalid': submitted && $v.assignedTo.$error,
                                }"
                              ></multiselect>
                            </div>
                            <div class="form-group">
                              <label for="">Re-assign to</label>
                              <multiselect
                                id="reAssignedTo"
                                v-model="reAssignedTo"
                                :options="officials"
                                :custom-label="reAssignLabel"
                                :class="{
                          'is-invalid': submitted && $v.reAssignedTo.$error,
                        }"
                              ></multiselect>
                              <input type="hidden" v-model="leaveID" >
                            </div>
                            <div class="form-group d-flex justify-content-center">
                              <b-button
                                v-if="!submitted"
                                type="submit"
                                class="btn btn-success btn-lg mt-4 d-flex justify-content-center"
                              >
                                Save Changes
                              </b-button>
                              <b-button v-else disabled class="btn btn-success btn-block mt-4">
                                Saving changes...
                              </b-button>
                            </div>
                          </form>
                        </div>
                      </div>

                      <div class="card-body" v-if="samStatus === 1">
                        <div class="p-3 bg-light mb-4 d-flex justify-content-between">
                          <div class="d-inline mb-0">
                            <h5 class="font-size-14 mb-0">Update Status & Re-assignment</h5>
                          </div>
                        </div>
                        <form @submit.prevent="restateSelfAssessment">
                          <div class="form-group">
                            <label for="status">
                              Status <span class="text-danger">*</span>
                            </label>
                            <select name="" id="" class="form-control">
                              <option value="0" selected>Pending</option>
                            </select>
                          </div>
                          <div class="form-group">
                            <label for="re-assign">
                              Re-assign To <span class="text-danger">*</span>
                            </label>
                            <multiselect
                              v-model="empId"
                              :options="officials"
                              :custom-label="authorizingAsLabel"
                              :class="{
                                'is-invalid': submitted && $v.roleId.$error,
                              }"
                            ></multiselect>
                          </div>
                          <b-button
                            v-if="!updating"
                            class="btn btn-success btn-block mt-4"
                            type="submit"
                          >
                            Re-state
                          </b-button>
                          <b-button
                            v-else
                            disabled
                            class="btn btn-success btn-block mt-4"
                            type="submit"
                          >
                            Submitting...
                          </b-button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-else-if="parseInt(activity) === 2">
              <div class="col-6">
                <div class="card mb-4">
                  <div class="card-body">
                    <div class="p-3 bg-light mb-4">
                      <h5 class="font-size-14 mb-0">Supervisor Details</h5>
                    </div>
                    <div class="d-flex justify-content-between text-capitalize">
                      <p>Supervisor Name</p>
                      <p>
                        {{ employee[0].supervisor.emp_first_name }}
                        {{ employee[0].supervisor.emp_last_name }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>T7 Number</p>
                      <p>
                        {{ employee[0].supervisor.emp_unique_id }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Phone Number</p>
                      <p>
                        {{ employee[0].supervisor.emp_phone_no }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Office Email</p>
                      <p>
                        {{ employee[0].supervisor.emp_office_email }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Sector Code</p>
                      <p>
                        {{ employee[0].supervisor.sector.d_t3_code }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Location Code</p>
                      <p>
                        {{ employee[0].supervisor.location.l_t6_code }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="card mb-4">
                  <div class="card-body">
                    <div class="p-3 bg-light mb-4">
                      <h5 class="font-size-14 mb-0">Employee Details</h5>
                    </div>
                    <div class="d-flex justify-content-between text-capitalize">
                      <p>Employee Name</p>
                      <p>
                        {{ employee[0].emp_first_name }}
                        {{ employee[0].emp_last_name }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>T7 Number</p>
                      <p>
                        {{ employee[0].emp_unique_id }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Phone Number</p>
                      <p>
                        {{ employee[0].emp_phone_no }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Office Email</p>
                      <p>
                        {{ employee[0].emp_office_email }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Sector Code</p>
                      <p>
                        {{ employee[0].sector.d_t3_code }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Location Code</p>
                      <p>
                        {{ employee[0].location.l_t6_code }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <div class="p-3 bg-light mb-4">
                      <h5 class="font-size-14 mb-0">Goal Setting Form</h5>
                    </div>
                    <div class="mb-3">
                      <h5 class="mb-2">
                        Mid Year Checking: {{ selectedYear }}
                      </h5>
                      <h5 class="mb-1">
                        Review Period
                        {{ new Date(selectedStart).toDateString() }} -
                        {{ new Date(selectedEnd).toDateString() }}
                      </h5>
                      <p class="mt-3">
                        Work with your manager to discuss and agree on at least
                        <strong>3</strong> goals for your work over this review
                        period.
                      </p>
                      <p>
                        Try to write at least 2-3 performance goals, focused on
                        your key areas of responsibility. Then, write 1 goal
                        about an area of growth/development. To create a
                        development goal, consider a strength you would like to
                        get even better in, or a challenging area you wish to
                        improve in.
                      </p>
                      <p>
                        Your goals should be SMART (specific, measurable,
                        actionable, realistic, timebound). For tips on creating
                        SMART goals,
                        <a
                          href="https://rescue.box.com/s/v5a0wfucoe1drhrz2cepy6wzr6urr3hr"
                          target="_blank"
                        >
                          click here.
                        </a>
                        For an e-learning module on how to write a good goal,
                        <a
                          href="https://kayaconnect.org/auth/saml2/login.php?wants=https://kayaconnect.org/course/info.php?id=1276&idp=dbcf769ab2c00b042dd2189fca3b115f&passive=off"
                          target="_blank"
                        >
                          click here.
                        </a>
                      </p>
                    </div>
                    <form>
                      <b-table-simple hover responsive bordered outlined>
                        <b-thead head-variant="dark">
                          <b-tr>
                            <b-th>S/n</b-th>
                            <b-th>Goal/Project</b-th>
                            <b-th>Update</b-th>
                            <b-th>Accomplishments</b-th>
                            <b-th>Challenges</b-th>
                            <b-th>Support Needed</b-th>
                            <b-th>Next Steps</b-th>
                            <b-th></b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <b-tr v-for="(field, index) in texts" :key="index">
                            <b-td style="width: 1%">
                              {{ index + 1 }}
                            </b-td>
                            <b-td style="width: 19%">
                              <textarea
                                type="text"
                                v-model="field.goal"
                                rows="6"
                                class="form-control"
                                :readonly="assessStatus === 1 ? true : false"
                              />
                            </b-td>
                            <b-td style="width: 11%">
                              <div class="form-group">
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    v-model="field.update"
                                    value="Complete"
                                    type="radio"
                                    :name="index"
                                    :checked="field.update === 'Complete'"
                                    :disabled="
                                      assessStatus === 1 ? true : false
                                    "
                                  />
                                  <label class="form-check-label">
                                    Complete
                                  </label>
                                </div>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    id="complete"
                                    v-model="field.update"
                                    value="On track"
                                    :checked="field.update === 'On track'"
                                    :disabled="
                                      assessStatus === 1 ? true : false
                                    "
                                    type="radio"
                                    :name="index"
                                  />
                                  <label class="form-check-label">
                                    On track
                                  </label>
                                </div>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    id="on-track"
                                    v-model="field.update"
                                    value="Delayed"
                                    type="radio"
                                    :name="index"
                                    :checked="field.update === 'Delayed'"
                                    :disabled="
                                      assessStatus === 1 ? true : false
                                    "
                                  />
                                  <label class="form-check-label">
                                    Delayed
                                  </label>
                                </div>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    v-model="field.update"
                                    value="Not started"
                                    type="radio"
                                    :name="index"
                                    :checked="field.update"
                                    :disabled="
                                      assessStatus === 1 ? true : false
                                    "
                                  />
                                  <label class="form-check-label">
                                    Not started
                                  </label>
                                </div>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    v-model="field.update"
                                    value="No longer relevant"
                                    type="radio"
                                    :name="index"
                                    :checked="
                                      field.update === 'No longer relevant'
                                    "
                                    :disabled="
                                      assessStatus === 1 ? true : false
                                    "
                                  />
                                  <label class="form-check-label">
                                    No longer relevant
                                  </label>
                                </div>
                              </div>
                            </b-td>
                            <b-td style="width: 17%">
                              <textarea
                                type="text"
                                v-model="field.accomplishment"
                                rows="6"
                                class="form-control"
                                :readonly="assessStatus === 1 ? true : false"
                              />
                            </b-td>
                            <b-td style="width: 17%">
                              <textarea
                                type="text"
                                v-model="field.challenge"
                                rows="6"
                                class="form-control"
                                :readonly="assessStatus === 1 ? true : false"
                              />
                            </b-td>
                            <b-td style="width: 17%">
                              <textarea
                                type="text"
                                v-model="field.support"
                                rows="6"
                                class="form-control"
                                :readonly="assessStatus === 1 ? true : false"
                              />
                            </b-td>
                            <b-td style="width: 17%; cursor: pointer">
                              <textarea
                                type="text"
                                v-model="field.next_step"
                                rows="6"
                                class="form-control"
                                :readonly="assessStatus === 1 ? true : false"
                              />
                            </b-td>
                            <b-td style="width: 1%" v-if="assessStatus === 0">
                              <button
                                v-if="index > 2"
                                type="button"
                                class="btn btn-sm btn-danger"
                                @click="delField(index)"
                              >
                                DEL
                              </button>
                            </b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
                      <div
                        class="alert alert-info d-flex mt-3"
                        v-if="assessStatus === 0"
                      >
                        <i class="ri-error-warning-line mr-2"></i>
                        You must submit a minimum of 3 goals.
                        <span
                          style="cursor: pointer; text-decoration: underline"
                          class="ml-1"
                          @click="addField"
                        >
                          Click here to add a new goal
                        </span>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="">Discussion Held on:</label>
                            <input
                              type="date"
                              v-model="sam_discussion_held_on"
                              placeholder="Discussion Held On"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label for="op">
                              Optional – other items to discuss (career
                              opportunities, area of growth & development, etc.)
                            </label>
                            <b-form-textarea
                              id="option"
                              no-resize
                              :readonly="assessStatus === 1 ? true : false"
                              rows="3"
                              v-model="optional"
                              placeholder="Optional"
                              class="form-control"
                              :class="{
                                'is-invalid': submitted && $v.optional.$error,
                              }"
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="card-body" v-if="samStatus === 1">
                  <div class="p-3 bg-light mb-4 d-flex justify-content-between">
                    <div class="d-inline mb-0">
                      <h5 class="font-size-14 mb-0">Update Status & Re-assignment</h5>
                    </div>
                  </div>

                  <form @submit.prevent="restateMidYearSelfAssessment">
                    <div class="form-group">
                      <label for="mid-year-assessment-status">
                        Status <span class="text-danger">*</span>
                      </label>
                      <select name="" id="sta" class="form-control">
                        <option value="0" selected>Pending</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label for="mid-year-assessment">
                         Re-assign To  <span class="text-danger">*</span>
                      </label>
                      <select
                        class="form-control"
                       v-model="empId"
                      >
                        <option v-for="(item,index) in officials" :key="index" :value="item.value">
                          {{ item.text || '' }}
                        </option>
                      </select>
                    </div>
                    <b-button
                      v-if="!updating"
                      class="btn btn-success btn-block mt-4"
                      type="submit"
                    >
                      Re-state
                    </b-button>
                    <b-button
                      v-else
                      disabled
                      class="btn btn-success btn-block mt-4"
                      type="submit"
                    >
                      Submitting...
                    </b-button>
                  </form>
                </div>
              </div>
            </div>
            <div class="row" v-else-if="parseInt(activity) === 3">
              <div class="col-6">
                <div class="card mb-4">
                  <div class="card-body" v-if="employee[0]">
                    <div class="p-3 bg-light mb-4">
                      <h5 class="font-size-14 mb-0">Supervisor Details</h5>
                    </div>
                    <div class="d-flex justify-content-between text-capitalize">
                      <p>Supervisor Name</p>
                      <p>
                        {{ employee[0].supervisor.emp_first_name }}
                        {{ employee[0].supervisor.emp_last_name }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>T7 Number</p>
                      <p>
                        {{ employee[0].supervisor.emp_unique_id }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Phone Number</p>
                      <p>
                        {{ employee[0].supervisor.emp_phone_no }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Office Email</p>
                      <p>
                        {{ employee[0].supervisor.emp_office_email }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Sector Code</p>
                      <p>
                        {{ employee[0].supervisor.sector.d_t3_code }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Location Code</p>
                      <p>
                        {{ employee[0].supervisor.location.l_t6_code }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="card mb-4">
                  <div class="card-body" v-if="employee[0]">
                    <div class="p-3 bg-light mb-4">
                      <h5 class="font-size-14 mb-0">Employee Details</h5>
                    </div>
                    <div class="d-flex justify-content-between text-capitalize">
                      <p>Employee Name</p>
                      <p>
                        {{ employee[0].emp_first_name }}
                        {{ employee[0].emp_last_name }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>T7 Number</p>
                      <p>
                        {{ employee[0].emp_unique_id }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Phone Number</p>
                      <p>
                        {{ employee[0].emp_phone_no }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Office Email</p>
                      <p>
                        {{ employee[0].emp_office_email }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Sector Code</p>
                      <p>
                        {{ employee[0].sector.d_t3_code }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Location Code</p>
                      <p>
                        {{ employee[0].location.l_t6_code }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <h5 class="mb-2">End of Year: {{ selectedYear }}</h5>
                <br />
                <h5 class="mb-1">
                  Review Period
                  {{ new Date(selectedStart).toDateString() }} -
                  {{ new Date(selectedEnd).toDateString() }}
                </h5>
              </div>
              <div class="col-6">
                <div class="card mb-4">
                  <div class="card-body">
                    <div class="p-3 bg-light mb-4">
                      <h5 class="font-size-14 mb-0">Supervisor Details</h5>
                    </div>
                    <div class="d-flex justify-content-between text-capitalize">
                      <p>Supervisor Name</p>
                      <p>
                        {{ employee[0].supervisor.emp_first_name }}
                        {{ employee[0].supervisor.emp_last_name }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>T7 Number</p>
                      <p>
                        {{ employee[0].supervisor.emp_unique_id }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Phone Number</p>
                      <p>
                        {{ employee[0].supervisor.emp_phone_no }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Office Email</p>
                      <p>
                        {{ employee[0].supervisor.emp_office_email }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Sector Code</p>
                      <p>
                        {{ employee[0].supervisor.sector.d_t3_code }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Location Code</p>
                      <p>
                        {{ employee[0].supervisor.location.l_t6_code }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="card mb-4">
                  <div class="card-body">
                    <div class="p-3 bg-light mb-4">
                      <h5 class="font-size-14 mb-0">Employee Details</h5>
                    </div>
                    <div class="d-flex justify-content-between text-capitalize">
                      <p>Employee Name</p>
                      <p>
                        {{ employee[0].emp_first_name }}
                        {{ employee[0].emp_last_name }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>T7 Number</p>
                      <p>
                        {{ employee[0].emp_unique_id }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Phone Number</p>
                      <p>
                        {{ employee[0].emp_phone_no }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Office Email</p>
                      <p>
                        {{ employee[0].emp_office_email }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Sector Code</p>
                      <p>
                        {{ employee[0].sector.d_t3_code }}
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p>Location Code</p>
                      <p>
                        {{ employee[0].location.l_t6_code }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="card">
                  <div class="card-body">
                    <div class="p-3 bg-light mb-4">
                      <h5 class="font-size-14 mb-0">Manager Evaluation</h5>
                    </div>
                    <div class="mt-5">
                      <p>
                        <strong class="font-size-14 mb-0">
                          Strength (required):
                        </strong>
                        Think about this employee’s achievements and identify an
                        area of strength that you have observed in them. An
                        example of a strength may be a task or process that
                        comes easily to your employee, and something that
                        excites/motivates them.
                      </p>
                      <div class="form-group">
                        <textarea
                          v-if="supervisorResponse"
                          v-model="supervisorResponse.eysr_strength"
                          type="text"
                          rows="4"
                          class="form-control"
                          readonly
                        />
                      </div>
                    </div>
                    <div class="mt-5">
                      <p>
                        <strong class="font-size-14 mb-0">
                          Growth Area (required):
                        </strong>
                        Identify an area of growth you wish this employee to
                        focus on in the next 6 months. This may be a task or
                        process your employee finds particularly challenging, or
                        something they need to learn more about in order to
                        excel in their role.
                      </p>
                      <div class="form-group">
                        <textarea
                          v-if="supervisorResponse"
                          v-model="supervisorResponse.eysr_growth"
                          type="text"
                          rows="4"
                          class="form-control"
                          readonly
                        />
                      </div>
                    </div>
                    <div class="mt-5">
                      <strong class="font-size-14 mb-0">
                        Select a rating for this employee (required):
                      </strong>
                      <b-list-group v-if="supervisorResponse" class="mt-3">
                        <b-list-group-item
                          href="#"
                          class="d-flex"
                          active
                          variant="secondary"
                        >
                          <div class="ml-1 mr-5 w-25 d-flex align-items-center">
                            {{ supervisorResponse.rating.rating_name }}
                          </div>
                          <div class="w-75">
                            {{ supervisorResponse.rating.rating_desc }}
                          </div>
                        </b-list-group-item>
                      </b-list-group>
                    </div>
                    <div class="mt-5">
                      <p>
                        <strong class="font-size-14 mb-0">
                          Additional comments:
                        </strong>
                      </p>
                      <div class="form-group">
                        <textarea
                          v-if="supervisorResponse"
                          v-model="supervisorResponse.eysr_additional_comment"
                          type="text"
                          rows="4"
                          class="form-control"
                          readonly
                        />
                      </div>
                    </div>
                    <div class="mt-5 mb-3">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="">Discussion held on:</label>
                            <input
                              type="date"
                              v-model="sam_discussion_held_on"
                              placeholder="Discussion Held On"
                              class="form-control"
                              readonly
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="card">
                  <div class="card-body">
                    <div class="p-3 bg-light mb-4">
                      <h5 class="font-size-14 mb-0">Employee Reflection</h5>
                    </div>
                    <div>
                      <p>
                        <strong class="font-size-14 mb-0">Reflection:</strong>
                        Consider your work and performance from this fiscal
                        year. Comment about your accomplishments and challenges.
                        If you wish, you may list your goals from this year and
                        comment on each goal. If you have at least one direct
                        report, comment on how you met or worked towards the
                        <a
                          href="https://rescue.app.box.com/s/w9mny3pek9xb0b2hwtz7uqxzlneh7nha"
                          target="_blank"
                        >
                          People Manager Standards.
                        </a>
                      </p>
                      <b-table-simple hover responsive bordered outlined>
                        <b-thead head-variant="dark">
                          <b-tr>
                            <b-th>S/n</b-th>
                            <b-th>Goal</b-th>
                            <b-th>Reflection</b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <b-tr
                            v-for="(data, index) in midYearCheckingQuestions"
                            :key="index"
                          >
                            <b-td style="width: 1%">
                              {{ index + 1 }}
                            </b-td>
                            <b-td style="width: 30%">
                              {{ data.eyr_goal }}
                            </b-td>
                            <b-td style="width: 70%">
                              {{ data.eyr_reflection }}
                            </b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
                    </div>
                    <div class="mt-5">
                      <p>
                        <strong class="font-size-14 mb-0">Strength:</strong>
                        Think about your achievements and identify an area of
                        strength that you have observed in yourself. An example
                        of a strength may be a task or process that comes easily
                        to you, and something that excites/motivates you.
                      </p>
                      <div class="form-group">
                        <textarea
                          type="text"
                          rows="4"
                          class="form-control"
                          v-model="eyr_strength"
                          readonly
                        />
                      </div>
                    </div>
                    <div class="mt-5">
                      <p>
                        <strong class="font-size-14 mb-0">Growth Area:</strong>
                        Identify a growth area you wish to focus on in the next
                        6 months. This may be a task or process you find
                        particularly challenging, or something you need to learn
                        more about to excel in your role.
                        <br />
                        Suggest 1-2 steps you can take to begin working on this
                        growth area.
                      </p>
                      <div class="form-group">
                        <textarea
                          type="text"
                          rows="4"
                          class="form-control"
                          v-model="eyr_growth_area"
                          readonly
                        />
                      </div>
                    </div>
                    <div class="mt-5">
                      <strong class="font-size-14 mb-0">
                        Check the applicable boxes:
                      </strong>
                      <ul class="mt-2">
                        <li
                          class="mb-3"
                          v-for="(question, index) in endOfYearQuestions"
                          :key="index"
                        >
                          <div class="d-flex justify-content-between">
                            <div>{{ question.eya_question }}</div>
                            <div>
                              <b-form-radio-group
                                :options="endOfYearQuestionOptions"
                                v-model="question.eyr_response"
                                disabled
                              />
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="Self-assessment"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="100%"
      ref="html2Pdf"
    >
      <section class="row" slot="pdf-content">
        <div class="col-12">
          <div class="text-center">
            <img
              style="width: 15%"
              src="data:image/png;base64,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"
              class="mt-3 mb-3"
            />
            <h4 class="mb-5">Self-assessment</h4>
          </div>
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="media mb-3">
                  <div>
                <span
                  class="badge badge-primary badge-pill"
                  v-if="parseInt(activity) === 1"
                >
                  Beginning of Year
                </span>
                <span
                  class="badge badge-primary badge-pill"
                  v-else-if="parseInt(activity) === 2"
                >
                  Mid-Year
                </span>
                <span class="badge badge-primary badge-pill" v-else>
                  End of Year
                </span>
                <span class="badge badge-primary badge-pill ml-3">
                  {{ selectedYear }}
                </span>
                  </div>
                </div>
                <div class="row" v-if="parseInt(activity) === 1">
                  <div class="col-lg-12">
                    <h5 class="mb-2">Beginning of Year: {{ selectedYear }}</h5>
                    <h5 class="mb-1">
                      Review Period
                      {{ new Date(selectedStart).toDateString() }} -
                      {{ new Date(selectedEnd).toDateString() }}
                    </h5>
                    <div class="row">
                      <div class="col-md-8">
                        <div class="row">
                          <div class="col-6">
                            <div class="card mb-4">
                              <div class="card-body">
                                <div class="p-3 bg-light mb-4">
                                  <h5 class="font-size-14 mb-0">Supervisor Details</h5>
                                </div>
                                <div
                                  class="d-flex justify-content-between text-capitalize"
                                >
                                  <p>Supervisor Name</p>
                                  <p>
                                    {{ employee[0].supervisor.emp_first_name }}
                                    {{ employee[0].supervisor.emp_last_name }}
                                  </p>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <p>T7 Number</p>
                                  <p>
                                    {{ employee[0].supervisor.emp_unique_id }}
                                  </p>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <p>Phone Number</p>
                                  <p>
                                    {{ employee[0].supervisor.emp_phone_no }}
                                  </p>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <p>Office Email</p>
                                  <p>
                                    {{ employee[0].supervisor.emp_office_email }}
                                  </p>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <p>Sector Code</p>
                                  <p>
                                    {{ employee[0].supervisor.sector.d_t3_code }}
                                  </p>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <p>Location Code</p>
                                  <p>
                                    {{ employee[0].supervisor.location.l_t6_code }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="card mb-4">
                              <div class="card-body">
                                <div class="p-3 bg-light mb-4">
                                  <h5 class="font-size-14 mb-0">Employee Details</h5>
                                </div>
                                <div
                                  class="d-flex justify-content-between text-capitalize"
                                >
                                  <p>Employee Name</p>
                                  <p>
                                    {{ employee[0].emp_first_name }}
                                    {{ employee[0].emp_last_name }}
                                  </p>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <p>T7 Number</p>
                                  <p>
                                    {{ employee[0].emp_unique_id }}
                                  </p>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <p>Phone Number</p>
                                  <p>
                                    {{ employee[0].emp_phone_no }}
                                  </p>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <p>Office Email</p>
                                  <p>
                                    {{ employee[0].emp_office_email }}
                                  </p>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <p>Sector Code</p>
                                  <p>
                                    {{ employee[0].sector.d_t3_code }}
                                  </p>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <p>Location Code</p>
                                  <p>
                                    {{ employee[0].location.l_t6_code }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-12"
                            v-for="(field, index) in assessments"
                            :key="index"
                          >
                            <div class="form-group">
                              <label for="goal" class="bg-light p-1">
                                Goal
                                <span class="badge-danger badge">{{ index + 1 }}</span>
                              </label>
                              <p
                                style="margin-left: 30px !important"
                                v-html="field.goal"
                              ></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-else-if="parseInt(activity) === 2">
                  <div class="col-6">
                    <div class="card mb-4">
                      <div class="card-body">
                        <div class="p-3 bg-light mb-4">
                          <h5 class="font-size-14 mb-0">Supervisor Details</h5>
                        </div>
                        <div class="d-flex justify-content-between text-capitalize">
                          <p>Supervisor Name</p>
                          <p>
                            {{ employee[0].supervisor.emp_first_name }}
                            {{ employee[0].supervisor.emp_last_name }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>T7 Number</p>
                          <p>
                            {{ employee[0].supervisor.emp_unique_id }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Phone Number</p>
                          <p>
                            {{ employee[0].supervisor.emp_phone_no }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Office Email</p>
                          <p>
                            {{ employee[0].supervisor.emp_office_email }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Sector Code</p>
                          <p>
                            {{ employee[0].supervisor.sector.d_t3_code }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Location Code</p>
                          <p>
                            {{ employee[0].supervisor.location.l_t6_code }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="card mb-4">
                      <div class="card-body">
                        <div class="p-3 bg-light mb-4">
                          <h5 class="font-size-14 mb-0">Employee Details</h5>
                        </div>
                        <div class="d-flex justify-content-between text-capitalize">
                          <p>Employee Name</p>
                          <p>
                            {{ employee[0].emp_first_name }}
                            {{ employee[0].emp_last_name }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>T7 Number</p>
                          <p>
                            {{ employee[0].emp_unique_id }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Phone Number</p>
                          <p>
                            {{ employee[0].emp_phone_no }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Office Email</p>
                          <p>
                            {{ employee[0].emp_office_email }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Sector Code</p>
                          <p>
                            {{ employee[0].sector.d_t3_code }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Location Code</p>
                          <p>
                            {{ employee[0].location.l_t6_code }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="card">
                      <div class="card-body">
                        <div class="p-3 bg-light mb-4">
                          <h5 class="font-size-14 mb-0">Goal Setting Form</h5>
                        </div>
                        <div class="mb-3">
                          <h5 class="mb-2">
                            Mid Year Checking: {{ selectedYear }}
                          </h5>
                          <h5 class="mb-1">
                            Review Period
                            {{ new Date(selectedStart).toDateString() }} -
                            {{ new Date(selectedEnd).toDateString() }}
                          </h5>
                          <p class="mt-3">
                            Work with your manager to discuss and agree on at least
                            <strong>3</strong> goals for your work over this review
                            period.
                          </p>
                          <p>
                            Try to write at least 2-3 performance goals, focused on
                            your key areas of responsibility. Then, write 1 goal
                            about an area of growth/development. To create a
                            development goal, consider a strength you would like to
                            get even better in, or a challenging area you wish to
                            improve in.
                          </p>
                          <p>
                            Your goals should be SMART (specific, measurable,
                            actionable, realistic, timebound). For tips on creating
                            SMART goals,
                            <a
                              href="https://rescue.box.com/s/v5a0wfucoe1drhrz2cepy6wzr6urr3hr"
                              target="_blank"
                            >
                              click here.
                            </a>
                            For an e-learning module on how to write a good goal,
                            <a
                              href="https://kayaconnect.org/auth/saml2/login.php?wants=https://kayaconnect.org/course/info.php?id=1276&idp=dbcf769ab2c00b042dd2189fca3b115f&passive=off"
                              target="_blank"
                            >
                              click here.
                            </a>
                          </p>
                        </div>
                        <form>
                          <b-table-simple hover responsive bordered outlined>
                            <b-thead head-variant="dark">
                              <b-tr>
                                <b-th>S/n</b-th>
                                <b-th>Goal/Project</b-th>
                                <b-th>Update</b-th>
                                <b-th>Accomplishments</b-th>
                                <b-th>Challenges</b-th>
                                <b-th>Support Needed</b-th>
                                <b-th>Next Steps</b-th>
                                <b-th></b-th>
                              </b-tr>
                            </b-thead>
                            <b-tbody>
                              <b-tr v-for="(field, index) in texts" :key="index">
                                <b-td style="width: 1%">
                                  {{ index + 1 }}
                                </b-td>
                                <b-td style="width: 19%">
                              <textarea
                                type="text"
                                v-model="field.goal"
                                rows="6"
                                class="form-control"
                                :readonly="assessStatus === 1 ? true : false"
                              />
                                </b-td>
                                <b-td style="width: 11%">
                                  <div class="form-group">
                                    <div class="form-check">
                                      <input
                                        class="form-check-input"
                                        v-model="field.update"
                                        value="Complete"
                                        type="radio"
                                        :name="index"
                                        :checked="field.update === 'Complete'"
                                        :disabled="
                                      assessStatus === 1 ? true : false
                                    "
                                      />
                                      <label class="form-check-label">
                                        Complete
                                      </label>
                                    </div>
                                    <div class="form-check">
                                      <input
                                        class="form-check-input"
                                        id="complete"
                                        v-model="field.update"
                                        value="On track"
                                        :checked="field.update === 'On track'"
                                        :disabled="
                                      assessStatus === 1 ? true : false
                                    "
                                        type="radio"
                                        :name="index"
                                      />
                                      <label class="form-check-label">
                                        On track
                                      </label>
                                    </div>
                                    <div class="form-check">
                                      <input
                                        class="form-check-input"
                                        id="on-track"
                                        v-model="field.update"
                                        value="Delayed"
                                        type="radio"
                                        :name="index"
                                        :checked="field.update === 'Delayed'"
                                        :disabled="
                                      assessStatus === 1 ? true : false
                                    "
                                      />
                                      <label class="form-check-label">
                                        Delayed
                                      </label>
                                    </div>
                                    <div class="form-check">
                                      <input
                                        class="form-check-input"
                                        v-model="field.update"
                                        value="Not started"
                                        type="radio"
                                        :name="index"
                                        :checked="field.update"
                                        :disabled="
                                      assessStatus === 1 ? true : false
                                    "
                                      />
                                      <label class="form-check-label">
                                        Not started
                                      </label>
                                    </div>
                                    <div class="form-check">
                                      <input
                                        class="form-check-input"
                                        v-model="field.update"
                                        value="No longer relevant"
                                        type="radio"
                                        :name="index"
                                        :checked="
                                      field.update === 'No longer relevant'
                                    "
                                        :disabled="
                                      assessStatus === 1 ? true : false
                                    "
                                      />
                                      <label class="form-check-label">
                                        No longer relevant
                                      </label>
                                    </div>
                                  </div>
                                </b-td>
                                <b-td style="width: 17%">
                              <textarea
                                type="text"
                                v-model="field.accomplishment"
                                rows="6"
                                class="form-control"
                                :readonly="assessStatus === 1 ? true : false"
                              />
                                </b-td>
                                <b-td style="width: 17%">
                              <textarea
                                type="text"
                                v-model="field.challenge"
                                rows="6"
                                class="form-control"
                                :readonly="assessStatus === 1 ? true : false"
                              />
                                </b-td>
                                <b-td style="width: 17%">
                              <textarea
                                type="text"
                                v-model="field.support"
                                rows="6"
                                class="form-control"
                                :readonly="assessStatus === 1 ? true : false"
                              />
                                </b-td>
                                <b-td style="width: 17%; cursor: pointer">
                              <textarea
                                type="text"
                                v-model="field.next_step"
                                rows="6"
                                class="form-control"
                                :readonly="assessStatus === 1 ? true : false"
                              />
                                </b-td>
                                <b-td style="width: 1%" v-if="assessStatus === 0">
                                  <button
                                    v-if="index > 2"
                                    type="button"
                                    class="btn btn-sm btn-danger"
                                    @click="delField(index)"
                                  >
                                    DEL
                                  </button>
                                </b-td>
                              </b-tr>
                            </b-tbody>
                          </b-table-simple>
                          <div
                            class="alert alert-info d-flex mt-3"
                            v-if="assessStatus === 0"
                          >
                            <i class="ri-error-warning-line mr-2"></i>
                            You must submit a minimum of 3 goals.
                            <span
                              style="cursor: pointer; text-decoration: underline"
                              class="ml-1"
                              @click="addField"
                            >
                          Click here to add a new goal
                        </span>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <label for="">Discussion Held on:</label>
                                <input
                                  type="date"
                                  v-model="sam_discussion_held_on"
                                  placeholder="Discussion Held On"
                                  class="form-control"
                                />
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-group">
                                <label for="op">
                                  Optional – other items to discuss (career
                                  opportunities, area of growth & development, etc.)
                                </label>
                                <b-form-textarea
                                  id="option"
                                  no-resize
                                  :readonly="assessStatus === 1 ? true : false"
                                  rows="3"
                                  v-model="optional"
                                  placeholder="Optional"
                                  class="form-control"
                                  :class="{
                                'is-invalid': submitted && $v.optional.$error,
                              }"
                                />
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-else-if="parseInt(activity) === 3">
                  <div class="col-6">
                    <div class="card mb-4">
                      <div class="card-body" v-if="employee[0]">
                        <div class="p-3 bg-light mb-4">
                          <h5 class="font-size-14 mb-0">Supervisor Details</h5>
                        </div>
                        <div class="d-flex justify-content-between text-capitalize">
                          <p>Supervisor Name</p>
                          <p>
                            {{ employee[0].supervisor.emp_first_name }}
                            {{ employee[0].supervisor.emp_last_name }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>T7 Number</p>
                          <p>
                            {{ employee[0].supervisor.emp_unique_id }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Phone Number</p>
                          <p>
                            {{ employee[0].supervisor.emp_phone_no }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Office Email</p>
                          <p>
                            {{ employee[0].supervisor.emp_office_email }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Sector Code</p>
                          <p>
                            {{ employee[0].supervisor.sector.d_t3_code }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Location Code</p>
                          <p>
                            {{ employee[0].supervisor.location.l_t6_code }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="card mb-4">
                      <div class="card-body" v-if="employee[0]">
                        <div class="p-3 bg-light mb-4">
                          <h5 class="font-size-14 mb-0">Employee Details</h5>
                        </div>
                        <div class="d-flex justify-content-between text-capitalize">
                          <p>Employee Name</p>
                          <p>
                            {{ employee[0].emp_first_name }}
                            {{ employee[0].emp_last_name }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>T7 Number</p>
                          <p>
                            {{ employee[0].emp_unique_id }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Phone Number</p>
                          <p>
                            {{ employee[0].emp_phone_no }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Office Email</p>
                          <p>
                            {{ employee[0].emp_office_email }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Sector Code</p>
                          <p>
                            {{ employee[0].sector.d_t3_code }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Location Code</p>
                          <p>
                            {{ employee[0].location.l_t6_code }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <h5 class="mb-2">End of Year: {{ selectedYear }}</h5>
                    <br />
                    <h5 class="mb-1">
                      Review Period
                      {{ new Date(selectedStart).toDateString() }} -
                      {{ new Date(selectedEnd).toDateString() }}
                    </h5>
                  </div>
                  <div class="col-6">
                    <div class="card mb-4">
                      <div class="card-body">
                        <div class="p-3 bg-light mb-4">
                          <h5 class="font-size-14 mb-0">Supervisor Details</h5>
                        </div>
                        <div class="d-flex justify-content-between text-capitalize">
                          <p>Supervisor Name</p>
                          <p>
                            {{ employee[0].supervisor.emp_first_name }}
                            {{ employee[0].supervisor.emp_last_name }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>T7 Number</p>
                          <p>
                            {{ employee[0].supervisor.emp_unique_id }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Phone Number</p>
                          <p>
                            {{ employee[0].supervisor.emp_phone_no }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Office Email</p>
                          <p>
                            {{ employee[0].supervisor.emp_office_email }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Sector Code</p>
                          <p>
                            {{ employee[0].supervisor.sector.d_t3_code }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Location Code</p>
                          <p>
                            {{ employee[0].supervisor.location.l_t6_code }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="card mb-4">
                      <div class="card-body">
                        <div class="p-3 bg-light mb-4">
                          <h5 class="font-size-14 mb-0">Employee Details</h5>
                        </div>
                        <div class="d-flex justify-content-between text-capitalize">
                          <p>Employee Name</p>
                          <p>
                            {{ employee[0].emp_first_name }}
                            {{ employee[0].emp_last_name }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>T7 Number</p>
                          <p>
                            {{ employee[0].emp_unique_id }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Phone Number</p>
                          <p>
                            {{ employee[0].emp_phone_no }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Office Email</p>
                          <p>
                            {{ employee[0].emp_office_email }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Sector Code</p>
                          <p>
                            {{ employee[0].sector.d_t3_code }}
                          </p>
                        </div>
                        <div class="d-flex justify-content-between">
                          <p>Location Code</p>
                          <p>
                            {{ employee[0].location.l_t6_code }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="card">
                      <div class="card-body">
                        <div class="p-3 bg-light mb-4">
                          <h5 class="font-size-14 mb-0">Manager Evaluation</h5>
                        </div>
                        <div class="mt-5">
                          <p>
                            <strong class="font-size-14 mb-0">
                              Strength (required):
                            </strong>
                            Think about this employee’s achievements and identify an
                            area of strength that you have observed in them. An
                            example of a strength may be a task or process that
                            comes easily to your employee, and something that
                            excites/motivates them.
                          </p>
                          <div class="form-group">
                        <textarea
                          v-if="supervisorResponse"
                          v-model="supervisorResponse.eysr_strength"
                          type="text"
                          rows="4"
                          class="form-control"
                          readonly
                        />
                          </div>
                        </div>
                        <div class="mt-5">
                          <p>
                            <strong class="font-size-14 mb-0">
                              Growth Area (required):
                            </strong>
                            Identify an area of growth you wish this employee to
                            focus on in the next 6 months. This may be a task or
                            process your employee finds particularly challenging, or
                            something they need to learn more about in order to
                            excel in their role.
                          </p>
                          <div class="form-group">
                        <textarea
                          v-if="supervisorResponse"
                          v-model="supervisorResponse.eysr_growth"
                          type="text"
                          rows="4"
                          class="form-control"
                          readonly
                        />
                          </div>
                        </div>
                        <div class="mt-5">
                          <strong class="font-size-14 mb-0">
                            Select a rating for this employee (required):
                          </strong>
                          <b-list-group v-if="supervisorResponse" class="mt-3">
                            <b-list-group-item
                              href="#"
                              class="d-flex"
                              active
                              variant="secondary"
                            >
                              <div class="ml-1 mr-5 w-25 d-flex align-items-center">
                                {{ supervisorResponse.rating.rating_name }}
                              </div>
                              <div class="w-75">
                                {{ supervisorResponse.rating.rating_desc }}
                              </div>
                            </b-list-group-item>
                          </b-list-group>
                        </div>
                        <div class="mt-5">
                          <p>
                            <strong class="font-size-14 mb-0">
                              Additional comments:
                            </strong>
                          </p>
                          <div class="form-group">
                        <textarea
                          v-if="supervisorResponse"
                          v-model="supervisorResponse.eysr_additional_comment"
                          type="text"
                          rows="4"
                          class="form-control"
                          readonly
                        />
                          </div>
                        </div>
                        <div class="mt-5 mb-3">
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label for="">Discussion held on:</label>
                                <input
                                  type="date"
                                  v-model="sam_discussion_held_on"
                                  placeholder="Discussion Held On"
                                  class="form-control"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="card">
                      <div class="card-body">
                        <div class="p-3 bg-light mb-4">
                          <h5 class="font-size-14 mb-0">Employee Reflection</h5>
                        </div>
                        <div>
                          <p>
                            <strong class="font-size-14 mb-0">Reflection:</strong>
                            Consider your work and performance from this fiscal
                            year. Comment about your accomplishments and challenges.
                            If you wish, you may list your goals from this year and
                            comment on each goal. If you have at least one direct
                            report, comment on how you met or worked towards the
                            <a
                              href="https://rescue.app.box.com/s/w9mny3pek9xb0b2hwtz7uqxzlneh7nha"
                              target="_blank"
                            >
                              People Manager Standards.
                            </a>
                          </p>
                          <b-table-simple hover responsive bordered outlined>
                            <b-thead head-variant="dark">
                              <b-tr>
                                <b-th>S/n</b-th>
                                <b-th>Goal</b-th>
                                <b-th>Reflection</b-th>
                              </b-tr>
                            </b-thead>
                            <b-tbody>
                              <b-tr
                                v-for="(data, index) in midYearCheckingQuestions"
                                :key="index"
                              >
                                <b-td style="width: 1%">
                                  {{ index + 1 }}
                                </b-td>
                                <b-td style="width: 30%">
                                  {{ data.eyr_goal }}
                                </b-td>
                                <b-td style="width: 70%">
                                  {{ data.eyr_reflection }}
                                </b-td>
                              </b-tr>
                            </b-tbody>
                          </b-table-simple>
                        </div>
                        <div class="mt-5">
                          <p>
                            <strong class="font-size-14 mb-0">Strength:</strong>
                            Think about your achievements and identify an area of
                            strength that you have observed in yourself. An example
                            of a strength may be a task or process that comes easily
                            to you, and something that excites/motivates you.
                          </p>
                          <div class="form-group">
                        <textarea
                          type="text"
                          rows="4"
                          class="form-control"
                          v-model="eyr_strength"
                          readonly
                        />
                          </div>
                        </div>
                        <div class="mt-5">
                          <p>
                            <strong class="font-size-14 mb-0">Growth Area:</strong>
                            Identify a growth area you wish to focus on in the next
                            6 months. This may be a task or process you find
                            particularly challenging, or something you need to learn
                            more about to excel in your role.
                            <br />
                            Suggest 1-2 steps you can take to begin working on this
                            growth area.
                          </p>
                          <div class="form-group">
                        <textarea
                          type="text"
                          rows="4"
                          class="form-control"
                          v-model="eyr_growth_area"
                          readonly
                        />
                          </div>
                        </div>
                        <div class="mt-5">
                          <strong class="font-size-14 mb-0">
                            Check the applicable boxes:
                          </strong>
                          <ul class="mt-2">
                            <li
                              class="mb-3"
                              v-for="(question, index) in endOfYearQuestions"
                              :key="index"
                            >
                              <div class="d-flex justify-content-between">
                                <div>{{ question.eya_question }}</div>
                                <div>
                                  <b-form-radio-group
                                    :options="endOfYearQuestionOptions"
                                    v-model="question.eyr_response"
                                    disabled
                                  />
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </VueHtml2pdf>
  </Layout>
</template>
